var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 51,
    viewBox: "0 0 189 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1861_57110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.488 50.7704H134.384L148.447 0H158.551L144.488 50.7704Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.237 1.60473C138.529 0.646606 137.447 0.146484 135.989 0.146484H80.4053L77.6567 10.0841H87.7607H128.219L125.279 20.7088H84.8209L74.7169 20.6879L66.3218 50.9794H76.4258L82.0514 30.6461H127.528C128.948 30.6461 130.28 30.1672 131.55 29.1879C132.802 28.2089 133.635 27.0213 134.029 25.6046L139.655 5.27139C140.07 3.79223 139.927 2.56314 139.237 1.60473Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4477 47.6046C59.883 49.6254 58.0516 51.0003 55.9663 51.0003H3.82095C2.40484 51.0003 1.34425 50.5211 0.654119 49.542C-0.0330257 48.5836 -0.179429 47.3754 0.21792 45.9587L12.948 0.146484H23.073L11.6962 41.063H52.175L63.5518 0.146484H73.6767L60.4895 47.6046H60.4477Z",
    fill: "#6D6E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.008 0.105469L188.801 25.5427L161.903 51.0008L176.008 0.105469Z",
    fill: "#008B44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.031 0.105469L179.82 25.5427L152.905 51.0008L167.031 0.105469Z",
    fill: "#F37920"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1861_57110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189,
    height: 51.0007,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/UPI.28967e3318c186304de0c9214298fb23.svg";
export { ForwardRef as ReactComponent };